import { DataField, Space, Text } from '@procurify/ui'

import { TextLoader } from '@webapp/core/components/ContentLoader'
import { useFormatTaxPercentage, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { TaxLabelTextStyled } from './styles/TaxDataFieldPresenterStyled'
import { useTaxDataFieldPresenter } from './useTaxDataFieldPresenter'

export interface ITaxDataFieldPresenterProps {
  id: number
  label?: string
  pay2776AutomatedRemittanceEmail?: boolean
}

export const TaxDataFieldPresenter = ({
  id,
  label,
  pay2776AutomatedRemittanceEmail,
}: ITaxDataFieldPresenterProps) => {
  const intl = useProcurifyIntl()
  const formatTaxPercentage = useFormatTaxPercentage()

  const {
    data: { tax },
    states: { showLoader },
  } = useTaxDataFieldPresenter({ id })

  return (
    <DataField label={label || intl.formatMessage(messages.fieldLabel)}>
      {showLoader && <TextLoader width={150} />}

      {!showLoader &&
        (!!tax ? (
          pay2776AutomatedRemittanceEmail ? (
            <Space direction='horizontal' size='xsmall' align='center'>
              <TaxLabelTextStyled>
                <Text autoMargin={false}>{tax.name}</Text>
              </TaxLabelTextStyled>
              <Text color='textSecondary'>
                {formatTaxPercentage(tax.percentage)}
              </Text>
            </Space>
          ) : (
            <>
              <Text bold autoMargin={false}>
                {tax.name}
              </Text>
              <Text color='textSecondary'>
                {formatTaxPercentage(tax.percentage)}
              </Text>
            </>
          )
        ) : pay2776AutomatedRemittanceEmail ? (
          <Text color='textTertiary' italic>
            {intl.formatMessage(messages.noDefaultTaxSet)}
          </Text>
        ) : (
          '--'
        ))}
    </DataField>
  )
}
